import Parse from "parse";

export interface IndustryAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
}

export class Industry extends Parse.Object<IndustryAttributes> {
  static className: string = "Antiscam_Industry";

  constructor(data?: Partial<IndustryAttributes>) {
    super("Antiscam_Industry", data as IndustryAttributes);
  }

  get name(): string {
    return super.get("name");
  }
  set name(value: string) {
    super.set("name", value);
  }
}

Parse.Object.registerSubclass("Antiscam_Industry", Industry);
